<template>
    <section>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

            <!--Groups list-->
            <el-tab-pane label="Nurse Payment Requests" name="first">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-select v-model="filters.paymentFilter" placeholder="User" @change="getPaymentRequest()"
                                       clearable filterable>
                                <el-option v-for="(nurse,index) in nurseList" :label="nurse.username"
                                           :value="nurse.userNo" :key="index"></el-option>
                            </el-select>
                            <el-select v-model="filters.paymentStatus" placeholder="Status"
                                       @change="getPaymentRequest()" clearable>
                                <el-option label="Pending" value="0"></el-option>
                                <el-option label="Confirmed" value="1"></el-option>
                                <el-option label="Rejected" value="4"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel('/excel/exportPaymentRequest','Active Offer.xls')">Export</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="showAdjust()">Adjust Balance</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="payments" highlight-current-row v-loading="firstListLoading" style="width: 100%;">
                    <el-table-column prop="paymentNo" label="#">
                    </el-table-column>
                    <el-table-column prop="createDate" label="Request Date">
                    </el-table-column>
                    <el-table-column prop="doctorNote" label="Doctor Note">
                        <template slot-scope="scope" >
                            <div v-html="scope.row.doctorNote"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nurseNote" label="Nurse Note">
                        <template slot-scope="scope" >
                            <div v-html="scope.row.nurseNote"></div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nurseName" label="User">
                    </el-table-column>
                    <el-table-column prop="amount" label="Amount">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.amount,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Status">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status===0">
                                <el-tag type="info">Pending</el-tag>
                            </p>
                            <p v-if="scope.row.status===1">
                                <el-tag type="success">Confirmed</el-tag>
                            </p>
                            <p v-if="scope.row.status===2">
                                <el-tag type="success">Canceled</el-tag>
                            </p>
                            <p v-if="scope.row.status===4">
                                <el-tag type="danger">Rejected</el-tag>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope" v-if="scope.row.status===0">
                            <el-button size="small" @click="requestPayment(scope.row.paymentNo)">Pay</el-button>
                            <el-button size="small" type="danger" @click="editPaymentStatus(scope.row.paymentNo,4)">
                                Reject
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changePaymentRequest"
                                   :page-size="pageSize" :total="paymentTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
            <!--open list-->
            <el-tab-pane label="Pending Transactions" name="second">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-input v-model="filters.pendingFilter" placeholder="Offer" clearable filterable>
                                <el-button slot="append" icon="el-icon-search"
                                           @click="getPendingTransaction"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="filters.pendingUser" placeholder="User" clearable filterable
                                       @change="getPendingTransaction">
                                <el-option v-for="(nurse,index) in nurseList" :label="nurse.username"
                                           :value="nurse.userNo" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="pendingPayments" highlight-current-row v-loading="secondListLoading"
                          style="width: 100%;">
                    <el-table-column prop="offerNo" label="#">
                    </el-table-column>
                    <el-table-column prop="productName" label="Offer">
                    </el-table-column>
                    <el-table-column prop="user" label="User">
                    </el-table-column>
                    <el-table-column prop="price" label="Price">
                    </el-table-column>
                    <el-table-column prop="quantity" label="Qty">
                    </el-table-column>
                    <el-table-column prop="warehouse" label="Warehouse">
                    </el-table-column>
                    <el-table-column prop="takeDate" label="Offer Create Date">
                    </el-table-column>
                    <el-table-column prop="inboundDate" label="Inbound Date">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changePendingRequest"
                                   :page-size="pageSize" :total="pendingTotal"
                                   style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <!--Invitations list-->
            <el-tab-pane label="Transaction" name="third">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-select v-model="filters.currentUser" placeholder="User" @change="getTransactionHistory"
                                       clearable filterable>
                                <el-option v-for="(nurse,index) in nurseList" :label="nurse.username"
                                           :value="nurse.userNo" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="filters.historyFilter" placeholder="Search Product Name, Note, Account etc." clearable>
                                <el-button slot="append" icon="el-icon-search"
                                           @click="getTransactionHistory"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportTransactionHistory">Export</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="transactions" highlight-current-row v-loading="thirdListLoading"
                          style="width: 100%;">
                    <el-table-column label="#" type="index"></el-table-column>
                    <el-table-column prop="dateTime" label="Date">
                    </el-table-column>
                    <el-table-column label="Transaction">
                        <template slot-scope="scope">
                            <div v-if="scope.row.type=='transaction'">
                                <p>For {{scope.row.productName}}, {{scope.row.dateTime}}</p>
                                <p class="note">${{scope.row.price}} * {{scope.row.quantity}}.
                                    {{scope.row.warehouse}}</p>
                            </div>
                            <div v-if="scope.row.type=='reported'">
                                <p>Reported for {{scope.row.productName}}, {{scope.row.dateTime}}</p>
                                <p class="note">${{scope.row.price}} * {{scope.row.quantity}}.
                                    {{scope.row.warehouse}}</p>
                            </div>
                            <div v-if="scope.row.type=='adjust'">
                                <p v-if="scope.row.amount>0">Increase Balance, {{scope.row.dateTime}}</p>
                                <p v-if="scope.row.amount<=0">Decrease Balance, {{scope.row.dateTime}}</p>
                                <div class="note" v-html="scope.row.note"></div>
                            </div>
                            <div v-if="scope.row.type=='payment'">
                                <p>Withdraw to {{scope.row.productName}}, {{scope.row.dateTime}}
                                    <span v-if="scope.row.status===0">(waiting for pay)</span>
                                    <span v-else-if="scope.row.status===1">(paid)</span>
                                    <span v-else-if="scope.row.status===2">(canceled)</span>
                                    <span v-else-if="scope.row.status===3">(rollover)</span>
                                </p>
                                <div class="note" v-html="scope.row.note"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="Amount">
                        <template slot-scope="scope">
                            <span v-if="scope.row.amount>=0" class="green-row">{{formatMoney(scope.row.amount,2)}}</span>
                            <span v-else="scope.row.amount<0" class="reported-row">{{formatMoney(scope.row.amount,2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Balance" prop="balance">
                    </el-table-column>
                    <el-table-column label="Nurse" prop="nurseName">
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeTransactionHistory"
                                   :page-size="pageSize"
                                   :total="historyTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Balance" name="fourth">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="filters">
                        <el-form-item>
                            <el-select v-model="filters.balanceFilter" placeholder="User" clearable filterable
                                       @change="getBalance">
                                <el-option v-for="(nurse,index) in nurseList" :label="nurse.username"
                                           :value="nurse.userNo" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table stripe :data="balances" highlight-current-row v-loading="fourthListLoading" @selection-change=""
                          style="width: 100%;">
                    <el-table-column type="index">
                    </el-table-column>
                    <el-table-column prop="userName" label="User">
                    </el-table-column>
                    <el-table-column prop="total" label="Balance">
                        <template slot-scope="scope">
                            <span v-if="scope.row.total>=0" class="green-row">{{formatMoney(scope.row.total,2)}}</span>
                            <span v-else="scope.row.total<0" class="reported-row">{{formatMoney(scope.row.total,2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pendingAmount" label="Pending">
                        <template slot-scope="scope">
                            <span v-if="scope.row.pendingAmount>=0" class="green-row">{{formatMoney(scope.row.pendingAmount,2)}}</span>
                            <span v-else="scope.row.pendingAmount<0" class="reported-row">{{formatMoney(scope.row.pendingAmount,2)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requestAmount" label="Requestable">
                        <template slot-scope="scope">
                            <span v-if="scope.row.requestAmount>=0" class="green-row">{{formatMoney(scope.row.requestAmount,2)}}</span>
                            <span v-else="scope.row.requestAmount<0" class="reported-row">{{formatMoney(scope.row.requestAmount,2)}}</span>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeBalance" :page-size="pageSize"
                                   :total="balanceTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>

            <el-tab-pane label="Warehouse fee payment" name="fifth">

                <!--列表-->
                <el-table stripe :data="storageFeePayments" highlight-current-row v-loading="fifthListLoading" @selection-change=""
                          style="width: 100%;">
                    <el-table-column type="index">
                    </el-table-column>
                    <el-table-column prop="userName" label="Warehouse">
                    </el-table-column>
                    <el-table-column prop="reportMonth" label="Report Month">
                    </el-table-column>
                    <el-table-column prop="totalFee" label="Total Fee">
                        <template slot-scope="scope">
                            {{formatMoney(scope.row.totalFee,2)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payStatus" label="Status">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.payStatus==0 && scope.row.totalFee > 0" type="info">Created</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==0 && scope.row.totalFee <= 0" type="success">No need to pay</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==1" type="success">Confirmed</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==2" type="warning">Canceled</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==3">Archived</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==4" type="danger">Rejected</el-tag>
                            <el-tag v-else-if="scope.row.payStatus==5" type="warning">Requested</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope" >
                            <el-button v-if="scope.row.totalFee > 0" size="small" :loading="loading" @click="showAddWarehousePayment(scope.row.id)">to Pay</el-button>
                            <el-button size="small" @click="getStorageFeePaymentSummary(scope.row.id)">
                                Detail
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="changeStorageFeePayment" :page-size="pageSize"
                                   :total="storageFeePaymentTotal" style="float:right;">
                    </el-pagination>
                </el-col>
            </el-tab-pane>
        </el-tabs>

        <!--收款列表界面-->
        <el-dialog title="Warehouse Payment List" width="80%" :visible.sync="paymentListVisible" :close-on-click-modal="false">
        
            <el-col :span="24" class="toolbar">
                <el-form :inline="true" :model="filters">
                    <el-select v-model="filters.warehousePaymentStatus" placeholder="Status" @change="getPaymentRequest4Warehouse()"
                                clearable>
                        <el-option label="Pending" value="0"></el-option>
                        <el-option label="Confirmed" value="1"></el-option>
                        <el-option label="Canceled" value="2"></el-option>
                        <el-option label="Archived" value="3"></el-option>
                        <el-option label="Rejected" value="4"></el-option>
                    </el-select>
                </el-form>
            </el-col>

            <!--列表-->
            <el-table stripe :data="warehousePayments" highlight-current-row v-loading="paymentLoading" style="width: 100%;">
                <el-table-column prop="paymentNo" label="#">
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                </el-table-column>
                <el-table-column prop="totalFee" label="Total Fee">
                    <template slot-scope="scope">
                        {{formatMoney(scope.row.totalFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="Apply amount">
                    <template slot-scope="scope">
                        {{formatMoney(scope.row.amount,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="doctorNote" label="Doctor Note">
                    <template slot-scope="scope" >
                        <div v-html="scope.row.doctorNote"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="warehouseNote" label="Warehouse Note">
                    <template slot-scope="scope" >
                        <div v-html="scope.row.warehouseNote"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="Request Date">
                </el-table-column>
                <el-table-column label="Status">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status===0">
                            <el-tag type="info">Pending</el-tag>
                        </p>
                        <p v-if="scope.row.status===1">
                            <el-tag type="success">Confirmed</el-tag>
                        </p>
                        <p v-if="scope.row.status===2">
                            <el-tag type="danger">Canceled</el-tag>
                        </p>
                        <p v-if="scope.row.status===4">
                            <el-tag type="warning">Rejected</el-tag>
                        </p>
                        <p v-if="scope.row.status===5">
                            <el-tag type="warning">Requested</el-tag>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope" v-if="scope.row.status===0">
                        <el-button size="small" @click="requestWarehousePayment(scope.row.paymentNo)" :loading="loading">Pay</el-button>
                        <el-button size="small" type="danger" @click="editWarehousePaymentStatus(scope.row.paymentNo,4)" :loading="loading">
                            Reject
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changePaymentRequest"
                                :page-size="pageSize" :total="paymentTotal"
                                style="float:right;">
                </el-pagination>
            </el-col>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="paymentListVisible = false;filters.paymentStatus = '';getStorageFeePaymentList();">Close</el-button>
            </div>
        </el-dialog>

        <!--给护士支付界面-->
        <el-dialog title="Confirm a payment" width="80%" :visible.sync="requestVisible" :close-on-click-modal="false">
            <el-form :model="payment" label-width="220px" ref="payment" :rules="payRule">
                <el-form-item label="User" prop="nurseName">
                    <el-input v-model="payment.nurseName" :disabled="true" auto-complete="off">
                    </el-input>
                </el-form-item>
                <el-form-item label="Amount" prop="amount">
                    <el-input-number v-model="payment.amount" :disabled="true" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Bank Account" prop="bank">
                    <el-input v-model="payment.bank" :disabled="true" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-form-item label="Bank Address" prop="bank">
                    <el-input v-model="payment.bankAddress" :disabled="true" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-form-item label="Note" prop="note">
<!--                    <el-input v-model="payment.note" type="textarea" rows="5"></el-input>-->
                    <quill-editor v-model="payment.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="requestVisible = false">Close</el-button>
                <el-button type="primary" @click.native="pay" :loading="loading">Confirm</el-button>
            </div>
        </el-dialog>

        <!--给仓库支付界面-->
        <el-dialog title="Confirm a payment 4 warehouse" width="80%" :visible.sync="warehouseRequestVisible" :close-on-click-modal="false">
            <el-form :model="warehousePayment" label-width="220px" ref="warehousePayment" :rules="payRule">
                <el-form-item label="User" prop="warehouseUserName">
                    <el-input v-model="warehousePayment.warehouseUserName" :disabled="true" auto-complete="off">
                    </el-input>
                </el-form-item>
                <el-form-item label="Total Amount" prop="totalFee">
                    <el-input-number v-model="warehousePayment.totalFee" :disabled="true" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Payable amount" prop="amount">
                    <el-input-number v-model="warehousePayment.amount" :disabled="true" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Bank Account" prop="bank">
                    <el-input v-model="warehousePayment.bank" :disabled="true" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-form-item label="Bank Address" prop="bank">
                    <el-input v-model="warehousePayment.bankAddress" :disabled="true" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-form-item label="Warehouse Note" prop="warehouseNote">
                    <quill-editor v-model="warehousePayment.warehouseNote" ref="myQuillEditor" :disabled="true" :options="readOlnyEditorOption" type="textarea" style="background-color:#F5F7FA;"></quill-editor>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <quill-editor v-model="warehousePayment.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseRequestVisible = false">Close</el-button>
                <el-button type="primary" @click.native="toWarehousePay" :loading="loading">Confirm</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Adjust Balance" width="80%" :visible.sync="adjustVisible" :close-on-click-modal="false">
            <el-form :model="adjust" label-width="220px" ref="adjust" :rules="adjustRule">
                <el-form-item label="User" prop="nurseId">
                    <el-select v-model="adjust.nurseId" placeholder="User" @change="getNusreBalance" filterable clearable>
                        <el-option v-for="(nurse,index) in nurseList" :label="nurse.username"
                                   :value="nurse.userNo" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Total Balance" prop="balance">
                    <el-input-number v-model="adjust.balance" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="Amount" prop="amount">
                    <el-input-number v-model="adjust.amount" :min="0"> </el-input-number>
                </el-form-item>
                <el-form-item >
                    <el-radio v-model="adjust.type" :label="1" che>Decrease Balance</el-radio>
                    <el-radio v-model="adjust.type" :label="2">Increase Balance</el-radio>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <quill-editor v-model="adjust.note" ref="myQuillEditor" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="adjustVisible = false">Close</el-button>
                <el-button type="primary" @click.native="addAdjust" :loading="loading">Confirm</el-button>
            </div>
        </el-dialog>

        <!--编辑界面-->
        <el-dialog title="Warehouse Fee Detail" width="80%" :visible.sync="warehouseFeeDetailModelVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-input v-model="filters.productName" placeholder="ProductName" @keyup.enter.native="getStorageFeePaymentDetail(null,1)" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-on:click="getStorageFeePaymentDetail(null,1)">Search</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="postExportExcel('/excel/exportWarehouseFeeDetail','Warehouse Fee Detail.xls',1)">Export</el-button>
                    </el-form-item>
                    <el-form-item style="float:right;">
                        <el-select clearable placeholder="Filter Fee Type" v-model="filters.feeType" :filterable="true" @change="getStorageFeePaymentDetail(null,1)">
                            <el-option v-for="(fee,index) in feeTypeList" :label="fee.value"
                                       :value="fee.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table stripe :data="warehouseFeeDetail" highlight-current-row v-loading="warehouseFeeLoading"
                      style="width: 100%;">
                <el-table-column prop="id" label="#">
                </el-table-column>
                <el-table-column prop="feeType" label="Fee Type">
                    <template slot-scope="scope" >
                        <p v-if="scope.row.feeType==0">Inbound</p>
                        <p v-if="scope.row.feeType==1">Outbound</p>
                        <p v-if="scope.row.feeType==2">Storage</p>
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="Product">
                </el-table-column>
                <el-table-column prop="upc" label="UPC">
                </el-table-column>
                <el-table-column prop="productSize" label="Category">
                </el-table-column>
                <el-table-column prop="baseFee" label="Storage Fee">
                </el-table-column>
                <el-table-column prop="baseFeeOver" label="Storage > Years Fee">
                </el-table-column>
                <el-table-column prop="qty" label="Storage Qty">
                    <!--                    <template slot-scope="scope" >-->
                    <!--                        <p v-if="scope.row.feeType==0">{{scope.row.inboundQty}}</p>-->
                    <!--                        <p v-if="scope.row.feeType==1">{{scope.row.service_qty}}</p>-->
                    <!--                        <p v-if="scope.row.feeType==2">{{scope.row.qty}}</p>-->
                    <!--                    </template>-->
                </el-table-column>
                <el-table-column prop="inboundFee" label="Inbound Fee">
                </el-table-column>
                <el-table-column prop="inboundRate" label="Inbound Rate">
                </el-table-column>
                <el-table-column prop="inboundQty" label="Inbound Qty">
                </el-table-column>
                <el-table-column prop="outboundFee" label="Outbound Fee">
                </el-table-column>
                <el-table-column prop="outboundRate" label="Outbound Rate">
                </el-table-column>
                <el-table-column prop="outboundQty" label="Outbound Qty">
                </el-table-column>
                <el-table-column prop="serviceFee" label="Service Fee">
                </el-table-column>
                <el-table-column prop="serviceType" label="Service Type">
                </el-table-column>
                <el-table-column prop="serviceQty" label="Service Qty">
                </el-table-column>
                <el-table-column prop="splitPackagesNum" label="Package Num">
                </el-table-column>
                <el-table-column prop="totalFee" label="Total Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.totalFee,5)}}
                    </template>
                </el-table-column>
                <el-table-column prop="inboundDate" label="Inbound Date">
                    <template slot-scope="scope">
                        {{dateFormat(scope.row.inboundDate)}}
                    </template>
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                    <template slot-scope="scope">
                        {{dateFormat(scope.row.reportDate)}}
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changeWarehouseFeeDetail"
                               :page-size="pageSize" :total="warehouseFeeDetailTotal" :current-page.sync="warehouseFeeDetailPage"
                               style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseFeeDetailModelVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <!--编辑界面-->
        <el-dialog title="Warehouse Fee Summary" width="80%" :visible.sync="warehouseFeeSummaryModelVisible" :close-on-click-modal="false">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item >
                        <el-input v-model="filters.conditionSearch" placeholder="Product Name or UPC" clearable @keyup.enter.native="getStorageFeePaymentSummary(warehouseFeeDetailId)" style="width: 400px">
                            <el-button slot="append" icon="el-icon-search" @click="getStorageFeePaymentSummary(warehouseFeeDetailId)"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="postExportExcel('/excel/exportWarehouseFeeSummary','Warehouse Fee Summary.xls',1)">Export</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table stripe :data="warehouseFeeSummary" highlight-current-row v-loading="warehouseFeeSummaryLoading"
                      style="width: 100%;">
                <el-table-column prop="productNo" label="Product No">
                </el-table-column>
                <el-table-column prop="productName" label="Product">
                </el-table-column>
                <el-table-column prop="upc" label="UPC">
                </el-table-column>
                <el-table-column prop="inboundFee" label="Inbound Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.inboundFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="outboundFee" label="Outbound Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.outboundFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="storageFee" label="Storage Fee">
                    <template slot-scope="scope">
                        ${{formatMoney(scope.row.storageFee,2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="reportDate" label="Report Date">
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope" >
                        <el-button size="small" @click="getStorageFeePaymentDetail(scope.row.productNo,1)">
                            Detail
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="prev, pager, next" @current-change="changeWarehouseFeeSummary"
                               :page-size="pageSize" :total="warehouseFeeSummaryTotal"
                               style="float:right;">
                </el-pagination>
            </el-col>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="warehouseFeeSummaryModelVisible = false">Close</el-button>
            </div>
        </el-dialog>

    </section>
</template>


<script>
    import { quillEditor } from 'vue-quill-editor'
    import util from '../../common/js/util'
    import {getOfferDetail} from "../../api/offerService";
    import {
        pay,
        getPaymentRequest,
        getBalance,
        getTransaction,
        editPaymentStatus,
        getPendingTransaction,
        getTransactionHistory,
        queryPaymentById,
        addAdjust
    } from "../../api/paymentService"
    import ElOption from "element-ui/packages/select/src/option";
    import {exportExcel, postExportExcel} from "../../api/exportService";
    import {defaultPageSize} from "../../globalVar";
    import {getDoctorNurse,getUserBalance} from "../../api/memberService";
    import ElInputNumber from "element-ui/packages/input-number/src/input-number";
    import {
        getDoctorList,
        storageFeePay,
        warehouseFeeDetail,
        warehouseFeeSummary
    } from "../../api/storageFeePaymentService";
    import {
        getPaymentRequest4Warehouse,
        addPaymentRequest4Warehouse,
        editPaymentStatus4Warehouse,
        queryPaymentById4Warehouse,
        pay4Warehouse,
    } from "../../api/paymentService4Warehouse";

    export default {
        components: {
            ElInputNumber,
            ElOption},
        data() {
            var checkAmount = (rule, value, callback) => {
                if (value<=0) {
                    return callback(new Error('Amount must more then 0.'));
                }else{
                    callback();
                }
            };
            return {
                readOlnyEditorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "Note",
                    height:"400px",
                    readOnly: true,
                    modules: {
                        toolbar: {
                            container: [
                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                            ]
                        }
                    }
                },
                editorOption: {
                    theme: "snow", // or 'bubble'
                    placeholder: "Note",
                    height:"400px",
                    modules: {
                        toolbar: {
                            container: [
                                ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                                ["link"] // 链接、图片、视频
                            ]
                        }
                    }
                },
                banks: [],
                activeName: "first",
                filters: {
                    currentUser: "",
                    pendingFilter: "",
                    pendingUser: "",
                    paymentFilter: "",
                    paymentStatus: "",
                    warehousePaymentStatus: "",
                    balanceFilter: "",
                    historyFilter: "",
                    name: '',
                    user: "",
                    productName:"",
                    feeType:"",
                    conditionSearch: "",
                },

                nurseList: [],

                firstListLoading: false,
                secondListLoading: false,
                thirdListLoading: false,
                fourthListLoading: false,
                fifthListLoading:false,

                pageSize: defaultPageSize,
                paymentPage: 1,
                paymentTotal: 0,

                pendingPage: 1,
                pendingTotal: 0,

                balancePage: 1,
                balanceTotal: 0,

                historyPage: 1,
                historyTotal: 0,

                warehouseFeeDetail:[],
                warehouseFeeSummary:[],

                storageFeePaymentPage:1,
                storageFeePaymentTotal:0,

                warehouseFeeDetailPage:1,
                warehouseFeeDetailTotal:0,
                warehouseFeeDetailModelVisible:false,

                warehouseFeeSummaryPage:1,
                warehouseFeeSummaryTotal:0,
                warehouseFeeSummaryModelVisible:false,

                warehouseFeeLoading:false,
                warehouseFeeSummaryLoading:false,
                warehouseFeeDetailId:null,
                warehouseFeeProductNo:null,

                feeTypeList:[
                    {id:0,value:"Inbound"},
                    {id:1,value:"Outbound"},
                    {id:2,value:"Storage"}
                ],

                offers: [],
                pendingPayments: [],
                payments: [],
                transactions: [],
                balances: [],
                storageFeePayments:[],
                total: 0,
                invitations: [],
                invitationTotalPage: 0,
                invitationPage: 1,
                listLoading: false,
                sels: [],//列表选中列
                requestVisible: false,//编辑界面是否显示
                addGroupVisible: false,
                invitationVisible: false,
                editLoading: false,
                payRule: {
                    note: [
                        {required: true, message: 'Note is requried.', trigger: 'blur'}
                    ]
                },

                warehouseRequestVisible: false,
                warehouseStorageFeeId: null,
                paymentLoading: false,
                paymentListVisible: false,//收款列表界面是否显示
                warehousePayments: [],
                warehousePaymentPage: 1,
                warehousePaymentTotal: 0,
                //仓库支付界面数据
                warehousePayment: {
                    warehouseUserName: "",
                    amount: "",
                    bank: "",
                    note: "",
                    paymentNo: "",
                    bankAddress:""
                },


                adjustRule: {
                    nurseId:[
                        {required: true, message: 'User is requried.', trigger: 'blur'}
                    ],
                    amount:[
                        {required: true, message: 'Amount is requried.', trigger: 'blur'},
                        { validator: checkAmount, trigger: 'blur' }
                    ],
                    note: [
                        {required: true, message: 'Note is requried.', trigger: 'blur'}
                    ]
                },

                addFormVisible: false,//新增界面是否显示
                adjustVisible:false,
                loading: false,
                //新增界面数据
                payment: {
                    nurseName: "",
                    amount: "",
                    bank: "",
                    note: "",
                    paymentNo: "",
                    bankAddress:""
                },
                adjust:{
                    nurseId:"",
                    amount:0.0,
                    note:"",
                    type:1,
                    balance:0
                }
            }
        },
        methods: {
            dateFormat(row,column){
                if(row){
                    let dT=new Date(row);//row 表示一行数据, dateTime 表示要格式化的字段名称
                    return dT.getFullYear()+"-"+(dT.getMonth()+1)+"-"+dT.getDate();
                }else{
                    return "";
                }
            },
            exportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName
                }
                exportExcel(param).then(function(){

                })
            },
            postExportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName,
                    payNo:this.warehouseFeeDetailId,
                    productNo:this.warehouseFeeProductNo,
                    productName:this.filters.productName,
                    feeType:this.filters.feeType,
                    condition: this.filters.conditionSearch,
                }
                postExportExcel(param).then(function(){

                })
            },
            formatMoney:function (s, n) {
                n = n > 0 && n <= 20 ? n : 2;
                s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                var l = s.split(".")[0].split("").reverse();
                let r = s.split(".")[1];
                let t = "";
                if (s < 0) {
                    l = ((Math.abs(s.split(".")[0])) + "").split("").reverse();
                }
                for (let i = 0; i < l.length; i++) {
                    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
                }
                if (s < 0) {
                    t += "-";
                }
                var result =  t.split("").reverse().join("") + "." + r;
                if(result==null||result==undefined||result.indexOf('NaN')>=0||result.indexOf('Undefined')>=0){
                    result = '0.00';
                }
                return result;
            },
            tableRowClassName({row, rowIndex}) {
                if (row.amount<0||row.total<0) {
                    return 'reported-row';
                } else {
                    return 'green-row';
                }
            },
            changePaymentRequest(val) {
                this.paymentPage = val;
                this.getPaymentRequest();
            },
            changePendingRequest(val) {
                this.pendingPage = val;
                this.getPendingTransaction();
            },
            changeBalance(val) {
                this.balancePage = val;
                this.getBalance();
            },
            changeTransactionHistory(val) {
                this.historyPage = val;
                this.getTransactionHistory();
            },
            changeStorageFeePayment(val) {
                this.storageFeePaymentPage = val;
                this.getStorageFeePaymentList();
            },
            changeWarehouseFeeDetail(val) {
                this.warehouseFeeDetailPage = val;
                this.getStorageFeePaymentDetail(this.warehouseFeeProductNo,val);
            },

            changeWarehouseFeeSummary(val) {
                this.warehouseFeeSummaryPage = val;
                this.getStorageFeePaymentSummary(this.warehouseFeeDetailId);
            },
            getTransactionHistory() {
                // if (this.filters.currentUser) {
                    let param = {
                        current: this.historyPage,
                        size: this.pageSize,
                        nurseNo: this.filters.currentUser,
                        condition: this.filters.historyFilter,
                    }
                    this.thirdListLoading = true;
                    getTransactionHistory(param).then((data) => {
                        this.thirdListLoading = false;
                        if (data.status === 200) {
                            this.transactions = data.result.records;
                            this.historyTotal = data.result.total;
                        }
                    })
                // } else {
                //     this.transactions = [];
                // }
            },
            getNurseList() {
                getDoctorNurse().then((data) => {
                    if (data.status === 200) {
                        this.nurseList = data.result;
                    }
                })
            },
            editPaymentStatus(paymentNo, status) {
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    let param = {
                        paymentNo: paymentNo,
                        status: status
                    };
                    editPaymentStatus(param).then((data) => {
                        if (data.status === 200) {
                            this.$message.success(data.message);
                            this.getPaymentRequest();
                        }
                    })
                }).catch(() => {
                })
            },
            editWarehousePaymentStatus(paymentNo, status) {
                let param = {
                    paymentNo: paymentNo,
                    status: status
                };
                this.loading = true;
                editPaymentStatus4Warehouse(param).then((data) => {
                    if (data.status === 200) {
                        this.$message.success(data.message);
                        this.getPaymentRequest4Warehouse();
                    }
                    this.loading = false;
                })
            },
            requestPayment(id) {
                queryPaymentById({paymentNo: id}).then((data) => {
                    if (data.status === 200) {
                        this.payment.paymentNo = data.result.paymentNo;
                        this.payment.nurseName = data.result.nurseName;
                        this.payment.amount = data.result.amount;
                        this.payment.bank = data.result.accountType + " " + data.result.accountNumber;
                        this.payment.bankAddress = data.result.bankAddress;
                        this.requestVisible = true;
                    }
                })
            },
            pay() {
                this.$refs.payment.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let param = {
                            paymentNo: this.payment.paymentNo,
                            note: this.payment.note
                        };
                        pay(param).then((data) => {
                            this.loading = false;
                            if (data.status === 200) {
                                this.$message.success(data.message);
                                this.requestVisible = false;
                                this.$refs.payment.resetFields();
                                this.getPaymentRequest();
                                this.getTransactionHistory();
                                this.getBalance();
                            } else {
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            requestWarehousePayment(id) {
                queryPaymentById4Warehouse({paymentNo: id}).then((data) => {
                    if (data.status === 200) {
                        this.warehousePayment.paymentNo = data.result.paymentNo;
                        this.warehousePayment.totalFee = data.result.totalFee;
                        this.warehousePayment.warehouseNote = data.result.warehouseNote;
                        this.warehousePayment.warehouseUserName = data.result.warehouseUserName;
                        this.warehousePayment.amount = data.result.amount;
                        this.warehousePayment.bank = data.result.accountType + " " + data.result.accountNumber;
                        this.warehousePayment.bankAddress = data.result.bankAddress;
                        this.warehouseRequestVisible = true;
                    }
                })
            },
            toWarehousePay() {
                this.$refs.warehousePayment.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let param = {
                            paymentNo: this.warehousePayment.paymentNo,
                            note: this.warehousePayment.note
                        };
                        pay4Warehouse(param).then((data) => {
                            this.loading = false;
                            if (data.status === 200) {
                                this.$message.success(data.message);
                                this.warehouseRequestVisible = false;
                                this.$refs.warehousePayment.resetFields();
                                this.paymentListVisible = false;
                                this.getStorageFeePaymentList();
                            } else {
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            requestStorageFeePayment(id){
                this.$confirm("Are you sure?", "Warning", {
                    type: "warning"
                }).then(() => {
                    this.loading = true;
                    let param = {
                        id: id
                    };
                    storageFeePay(param).then((data) => {
                        this.loading = false;
                        if (data.status === 200&&data.result.flag) {
                            this.$message.success(data.message);
                            this.getStorageFeePaymentList();
                        } else {
                            this.$message.error(data.message);
                        }
                    })
                })
            },
            getBalance() {
                let param = {
                    current: this.balancePage,
                    size: this.pageSize,
                    userNo: this.filters.balanceFilter
                };
                this.fourthListLoading = true;
                getBalance(param).then((data) => {
                    this.fourthListLoading = false;
                    if (data.status === 200) {
                        this.balances = data.result.records;
                        this.balanceTotal = data.result.total;
                    }
                })
            },
            changeOfferSelect() {

            },
            handleClick() {

            },
            getPendingTransaction() {
                let param = {
                    current: this.pendingPage,
                    size: this.pageSize,
                    condition: this.filters.pendingFilter,
                    userNo: this.filters.pendingUser
                };
                this.secondListLoading = true;
                getPendingTransaction(param).then((data) => {
                    this.secondListLoading = false;
                    if (data.status === 200) {
                        this.pendingPayments = data.result.records;
                        this.pendingTotal = data.result.total;
                    }
                })
            },
            getPaymentRequest() {
                let param = {
                    current: this.paymentPage,
                    size: this.pageSize,
                    condition: this.filters.paymentFilter,
                    status: this.filters.paymentStatus
                };
                this.firstListLoading = true;
                getPaymentRequest(param).then((data) => {
                    this.firstListLoading = false;
                    if (data.status === 200) {
                        this.payments = data.result.records;
                        this.paymentTotal = data.result.total;
                        //this.transactionHistory = data;
                    }
                })
            },
            getPaymentRequest4Warehouse() {
                let user = JSON.parse(sessionStorage.getItem("user"));
                let param = {
                    current: this.warehousePaymentPage,
                    size: this.pageSize,
                    status: this.filters.warehousePaymentStatus,
                    doctorNo: user.userNo,
                    storageFeeId: this.warehouseStorageFeeId,
                };
                this.firstListLoading = true;
                getPaymentRequest4Warehouse(param).then((data) => {
                    this.firstListLoading = false;
                    if (data.status === 200) {
                        this.warehousePayments = data.result.records;
                        this.paymentTotal = data.result.total;
                        //this.transactionHistory = data;
                    }
                })
            },
            getStorageFeePaymentList() {
                let param = {
                    current: this.storageFeePaymentPage,
                    size: this.pageSize
                };
                this.fifthListLoading = true;
                getDoctorList(param).then((data) => {
                    this.fifthListLoading = false;
                    if (data.status === 200) {
                        this.storageFeePayments = data.result.records;
                        this.storageFeePaymentTotal = data.result.total;
                    }
                })
            },
            getStorageFeePaymentDetail(productNo,page) {
                this.warehouseFeeDetailPage = page;
                if(productNo){
                    this.warehouseFeeProductNo= productNo;
                }
                let param = {
                    current: page,
                    size: this.pageSize,
                    payNo:this.warehouseFeeDetailId,
                    productNo:this.warehouseFeeProductNo,
                    productName:this.filters.productName,
                    feeType:this.filters.feeType
                };
                this.warehouseFeeDetailModelVisible = true;
                this.warehouseFeeLoading = true;
                warehouseFeeDetail(param).then((data) => {
                    this.warehouseFeeLoading = false;
                    if (data.status === 200) {
                        this.warehouseFeeDetail = data.result.records;
                        this.warehouseFeeDetailTotal = data.result.total;
                    }
                })
            },
            getStorageFeePaymentSummary(id) {
                this.warehouseFeeDetailId = id;
                let param = {
                    current: this.warehouseFeeSummaryPage,
                    size: this.pageSize,
                    payNo:id,
                    condition: this.filters.conditionSearch,
                };
                this.warehouseFeeSummaryModelVisible = true;
                this.warehouseFeeSummaryLoading = true;
                warehouseFeeSummary(param).then((data) => {
                    this.warehouseFeeSummaryLoading = false;
                    if (data.status === 200) {
                        this.warehouseFeeSummary = data.result.records;
                        this.warehouseFeeSummaryTotal = data.result.total;
                    }
                })
            },
            showAdjust(){
                this.adjust.amount = 0.0;
                this.adjust.type = 1;
                this.adjust.nurseId = "";
                this.adjust.note = "";
                this.adjustVisible = true;

            },
            getNusreBalance(){
                if(this.adjust.nurseId){
                    let user = JSON.parse(sessionStorage.getItem("user"));
                    let param = {
                        doctorNo:user.userNo,
                        nurseNo:this.adjust.nurseId
                    }
                    getUserBalance(param).then((res)=>{
                        if(res.status===200){
                            this.adjust.balance = res.result.balance;
                        }
                    })
                }else{
                    this.adjust.balance = 0.0
                }

            },
            addAdjust(){
                this.$refs.adjust.validate((valid) => {
                    if(valid){
                        this.loading = true;
                        var amount = this.adjust.amount;
                        if(this.adjust.type=="1"){
                            amount = amount*-1;
                        }
                        console.log(this.adjust.amount)
                        let param = {
                            nurseId:this.adjust.nurseId,
                            amount:amount,
                            note:this.adjust.note
                        };

                        addAdjust(param).then((data)=>{
                            this.loading = false;
                            if (data.status === 200) {
                                this.adjustVisible = false;
                                this.$message.success("Success");
                                this.getTransactionHistory();
                                this.getBalance();
                            }else{
                                this.$message.error(data.message)
                            }
                        })
                    }
                })
            },
            exportTransactionHistory(){
                let param = {
                    url:'/excel/exportTransactionHistory',
                    fileName:'Transaction History.xls',
                    nurseNo: this.filters.currentUser,
                    condition: this.filters.historyFilter,
                }
                postExportExcel(param).then(function(){

                })
            },
            showAddWarehousePayment(id) {
                this.warehouseStorageFeeId = id;
                let user = JSON.parse(sessionStorage.getItem("user"));
                let param = {
                    current: this.warehousePaymentPage,
                    size: this.pageSize,
                    status: this.filters.warehousePaymentStatus,
                    doctorNo: user.userNo,
                    storageFeeId: id,
                };
                getPaymentRequest4Warehouse(param).then((data) => {
                    this.paymentLoading = false;
                    this.isPaymentPending = false;
                    if (data.status === 200) {
                        this.paymentListVisible = true;
                        this.warehousePayments = data.result.records;
                        this.paymentTotal = data.result.total;
                        for (var i = 0; i < this.warehousePayments.length; i++) {
                            var p = this.warehousePayments[i];
                            if (p.status == 0 || p.status == 1) {
                                // 有正在处理的记录，或者有已支付的记录，不能再发起申请支付请求
                                this.isPaymentPending = true;
                                break;
                            }
                        }
                    }
                })
            },

        },
        mounted() {
            this.getNurseList();
            this.getPendingTransaction();
            this.getPaymentRequest();
            this.getBalance();
            this.getTransactionHistory();
            this.getStorageFeePaymentList();
            let active = this.$route.params.active;
            if(active){
                this.activeName = active;
            }
        }
    }

</script>
<style>

</style>


// WEBPACK FOOTER //
// payments.vue?1203f061